import React, { useState } from 'react'
import { graphql } from 'gatsby'

import PageHeader from '../components/data-sources/PageHeader'
import Layout from '../components/common/Layout'
import Grid from '../components/data-sources/Grid'

const DataSources = ({ data }) => {
  const dataSources = data.sources.nodes.flatMap((source) => source.frontmatter)

  const sortedSources = dataSources.sort((a, b) => {
    const titleA = a.title.toLowerCase()
    const titleB = b.title.toLowerCase()

    if (titleA < titleB) {
      return -1
    }
    if (titleA > titleB) {
      return 1
    }
    return 0
  })

  return (
    <Layout
      title="Top GIS Data Sources for Your Projects"
      meta={{
        description:
          'Discover the best GIS data sources to use in your projects and research',
        title: 'Top GIS Data Sources for Your Projects | Atlas Data Sources',
        absoluteImageUrl: 'https://atlas.co/images/data-sources-og.png',
        type: 'website'
      }}
    >
      <main>
        <PageHeader subtitle="Discover the best GIS data sources to use in your projects and research" />
        <Grid data={sortedSources} />
      </main>
    </Layout>
  )
}

export default DataSources

export const pageQuery = graphql`
  query {
    sources: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/data-sources/[^/]+\\.md$/" } }
      limit: 1000
    ) {
      nodes {
        id
        frontmatter {
          title
          excerpt
          tags
          featuredImage
        }
      }
    }
  }
`
